import moment from 'moment';
import { Dispatch } from 'redux';
import { ReferencePunchCardDTO } from '../../models/dto/ReferencePunchCardDTO';
import { api } from '../../services/api';
import {
  findPeriodOccurrencesStatus,
  findTodayOccurrencesStatus,
} from '../../services/peopleManagement.service';

export const punchCardActionsTypes = {
  GET_TODAY_REFERENCE_PUNCH_CARD: 'GET_TODAY_REFERENCE_PUNCH_CARD',
  GET_TODAY_REFERENCE_PUNCH_CARD_SUCCESS:
    'GET_TODAY_REFERENCE_PUNCH_CARD_SUCCESS',
  GET_TODAY_REFERENCE_PUNCH_CARD_FAILURE:
    'GET_TODAY_REFERENCE_PUNCH_CARD_FAILURE',

  GET_PERIOD_REFERENCE_PUNCH_CARD: 'GET_PERIOD_REFERENCE_PUNCH_CARD',
  GET_PERIOD_REFERENCE_PUNCH_CARD_SUCCESS:
    'GET_PERIOD_REFERENCE_PUNCH_CARD_SUCCESS',
  GET_PERIOD_REFERENCE_PUNCH_CARD_FAILURE:
    'GET_PERIOD_REFERENCE_PUNCH_CARD_FAILURE',

  GET_TODAY_OCCURRENCES_STATUS: 'GET_TODAY_OCCURRENCES_STATUS',
  GET_TODAY_OCCURRENCES_STATUS_SUCCESS: 'GET_TODAY_OCCURRENCES_STATUS_SUCCESS',
  GET_TODAY_OCCURRENCES_STATUS_FAILURE: 'GET_TODAY_OCCURRENCES_STATUS_FAILURE',

  GET_PERIOD_OCCURRENCES_STATUS: 'GET_PERIOD_OCCURRENCES_STATUS',
  GET_PERIOD_OCCURRENCES_STATUS_SUCCESS:
    'GET_PERIOD_OCCURRENCES_STATUS_SUCCESS',
  GET_PERIOD_OCCURRENCES_STATUS_FAILURE:
    'GET_PERIOD_OCCURRENCES_STATUS_FAILURE',
};

export const getReferencePunchCard = async (
  dateFrom: string,
  dateTo: string,
  reference: number | undefined,
) => {
  // eslint-disable-next-line no-useless-catch
  try {
    return await api.get<ReferencePunchCardDTO[]>(
      `/gdp/pontos/referencias/${reference}`,
      {
        params: {
          periodoDe: dateFrom,
          periodoAte: dateTo,
        },
      },
    );
  } catch (error) {
    throw error;
  }
};

export const getTodayReferencePunchCard = (
  reference: number | undefined,
) => async (dispatch: Dispatch) => {
  dispatch({ type: punchCardActionsTypes.GET_TODAY_REFERENCE_PUNCH_CARD });
  try {
    const { data } = await getReferencePunchCard(
      moment().format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD'),
      reference,
    );
    dispatch({
      type: punchCardActionsTypes.GET_TODAY_REFERENCE_PUNCH_CARD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: punchCardActionsTypes.GET_TODAY_REFERENCE_PUNCH_CARD_FAILURE,
    });
  }
};

export const getPeriodReferencePunchCard = (
  dateFrom: string,
  dateTo: string,
  reference: number | undefined,
) => async (dispatch: Dispatch) => {
  dispatch({ type: punchCardActionsTypes.GET_PERIOD_REFERENCE_PUNCH_CARD });
  try {
    const { data } = await getReferencePunchCard(dateFrom, dateTo, reference);
    dispatch({
      type: punchCardActionsTypes.GET_PERIOD_REFERENCE_PUNCH_CARD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: punchCardActionsTypes.GET_TODAY_REFERENCE_PUNCH_CARD_FAILURE,
    });
  }
};

export const getTodayOccurrencesStatus = (reference: number) => async (
  dispatch: Dispatch,
) => {
  dispatch({ type: punchCardActionsTypes.GET_TODAY_OCCURRENCES_STATUS });
  try {
    const { data } = await findTodayOccurrencesStatus(reference);
    dispatch({
      type: punchCardActionsTypes.GET_TODAY_OCCURRENCES_STATUS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: punchCardActionsTypes.GET_TODAY_OCCURRENCES_STATUS_FAILURE,
    });
  }
};

export const getPeriodOccurrencesStatus = (
  dateFrom: string,
  dateTo: string,
  reference: number,
) => async (dispatch: Dispatch) => {
  dispatch({ type: punchCardActionsTypes.GET_PERIOD_OCCURRENCES_STATUS });
  try {
    const { data } = await findPeriodOccurrencesStatus(
      reference,
      dateFrom,
      dateTo,
    );
    dispatch({
      type: punchCardActionsTypes.GET_PERIOD_OCCURRENCES_STATUS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error);
    dispatch({
      type: punchCardActionsTypes.GET_PERIOD_OCCURRENCES_STATUS_FAILURE,
    });
  }
};
